module.exports = __webpack_public_path__ + "img/green-3-squiggly-open.0c034e9c.svg";